import {
  WORKFLOWS_ACTION_TYPES,
  WorkflowsState,
  WorkflowsActionTypes,
} from './workflows.types';

const initialState: WorkflowsState = {
  workflows: [],
  selectedWorkflow: null,
  loading: false,
  error: null,
  updateLoading: false,
  publishLoading: false,
};

const workflowsReducer = (
  state: WorkflowsState = initialState,
  action: WorkflowsActionTypes
): WorkflowsState => {
  switch (action.type) {
    case WORKFLOWS_ACTION_TYPES.FETCH_WORKFLOWS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case WORKFLOWS_ACTION_TYPES.FETCH_WORKFLOWS_SUCCESS:
      return {
        ...state,
        workflows: action.payload,
        loading: false,
        error: null,
      };

    case WORKFLOWS_ACTION_TYPES.FETCH_WORKFLOWS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case WORKFLOWS_ACTION_TYPES.GET_WORKFLOW_BY_CAMPAIGN_REQUEST:
      return {
        ...state,
        selectedWorkflow: null,
        loading: true,
        error: null,
      };

    case WORKFLOWS_ACTION_TYPES.GET_WORKFLOW_BY_CAMPAIGN_SUCCESS:
      return {
        ...state,
        selectedWorkflow: action.payload,
        loading: false,
        error: null,
      };

    case WORKFLOWS_ACTION_TYPES.GET_WORKFLOW_BY_CAMPAIGN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case WORKFLOWS_ACTION_TYPES.UPDATE_WORKFLOW_REQUEST:
      return {
        ...state,
        updateLoading: true,
        error: null,
      };

    case WORKFLOWS_ACTION_TYPES.UPDATE_WORKFLOW_SUCCESS:
      return {
        ...state,
        selectedWorkflow: action.payload,
        updateLoading: false,
        error: null,
      };

    case WORKFLOWS_ACTION_TYPES.UPDATE_WORKFLOW_FAILURE:
      return {
        ...state,
        updateLoading: false,
        error: action.payload,
      };

    case WORKFLOWS_ACTION_TYPES.PUBLISH_WORKFLOW_REQUEST:
      return {
        ...state,
        publishLoading: true,
        error: null,
      };

    case WORKFLOWS_ACTION_TYPES.PUBLISH_WORKFLOW_SUCCESS:
      return {
        ...state,
        selectedWorkflow: action.payload,
        publishLoading: false,
        error: null,
      };

    case WORKFLOWS_ACTION_TYPES.PUBLISH_WORKFLOW_FAILURE:
      return {
        ...state,
        publishLoading: false,
        error: action.payload,
      };

    case WORKFLOWS_ACTION_TYPES.CLEAR_WORKFLOW_STATE:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export default workflowsReducer;
